module.exports = __webpack_public_path__ + "img/bg-card.08f80a19.svg";